import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk'; // Correct import
import authReducer from './reducers/authReducers';

const rootReducer = combineReducers({
	auth: authReducer,
});

// Use the Redux DevTools extension if it's available
const composeEnhancers =
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (f => f);

const store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(thunk))
);

export default store;
